import * as React from 'react';

export function IconClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={props.fill ?? 'currentColor'} {...props}>
      <path d="M317.1 256L499.2 73.9c16.7-16.7 16.7-43.7 0-60.4-16.7-16.7-43.7-16.7-60.4 0L256.7 195.6 74.6 12.5c-16.7-16.7-43.7-16.7-60.4 0-8.4 8.4-13 19.5-13 30.7s4.6 22.3 13 30.7L196.3 256 13.2 438.1c-8.4 8.4-13 19.5-13 30.7s4.6 22.3 13 30.7c16.7 16.7 43.7 16.7 60.4 0l183.1-183.1 182.1 182.1c16.7 16.7 43.7 16.7 60.4 0 16.7-16.7 16.7-43.7 0-60.4L317.1 256z" />
    </svg>
  );
}
